import { LinearLoader } from '@advanza/ui'
import clsx from 'clsx'
import React from 'react'
import style from './loadBoxWrapper.module.css'

const LoadBoxWrapper = ({ isLoading, children }) => {
    return (
        <div className={clsx(style.root, isLoading && style.isLoading)}>
            {isLoading && <LinearLoader fixed />}
            {children}
        </div>
    )
}

export default LoadBoxWrapper
